import * as React from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const createFontAwesomeIcon = (icon: IconProp) => {
  const FontAwesome = ({
    className,
    ...props
  }: Omit<FontAwesomeIconProps, 'icon'>) => (
    <FontAwesomeIcon className={className} icon={icon} {...props} />
  );

  return FontAwesome;
};
